import React, { memo, forwardRef } from "react";
const SvgCapitalSigma = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11 24.136a1 1 0 01-1-1v-.425a1 1 0 01.22-.625l5.444-6.806-5.19-6.201a1 1 0 01-.234-.642V8a1 1 0 011-1h9.392a.96.96 0 110 1.92H14.128c-.496 0-.872-.008-1.128-.024l4.706 5.579a.906.906 0 01.017 1.149l-5.251 6.592h1.752a65.821 65.821 0 011.824-.024h4.86a.972.972 0 010 1.944H11z"
      />
    </svg>
  );
});
SvgCapitalSigma.displayName = "SvgCapitalSigma";
const MemoForwardRef = memo(SvgCapitalSigma);
export default MemoForwardRef;
